import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import Sidebar from "../component/Sidebar";
import Topbar from "../component/Topbar";
import Footer from "../component/Footer";
import copy from "copy-to-clipboard";
import { BASE_URL } from "../api";
import axios from "axios";
import { getApiHeaders, shortAddress } from "../utils/helpers";
import MessageToster from "../component/MessageToster";
import { useHandleError } from "../hooks/useHandleError";
import Loader from "../component/Loader";
import { formatDateDDMMYYYY } from "../utils/dateUtils";
import CommonTable from "../component/CommonTable";
import { useUser } from "../context/UserContext";
import ExportButton from "../component/ExportButton";
import { exportToExcel } from "../utils/exportData";
import MobileFilter from "../component/MobileFilter";

export default function Wallet() {
  const mid = Number(sessionStorage.getItem("mid"));
  const handleError = useHandleError();
  const { userData, fetchUserData } = useUser();
  const [tableData, setTableData] = useState([]);
  const [filteredTableData, setFilteredTableData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [filters, setFilters] = useState({
    fromDate: "",
    toDate: "",
    transactionType: "All",
    walletType: "All",
  });

  const getWalletDisplayName = (walletKey) => {
    if (!walletKey) return "-";
    const key = String(walletKey).toUpperCase().trim();
    if (key.includes("PIN") || key.includes("DEPOSIT")) {
      return "Deposit Wallet";
    }
    if (key.includes("COMMISSION") || key.includes("INCOME")) {
      return "Income Wallet";
    }
    return walletKey.replace(/_/g, " ");
  };

  const getWalletBadge = (walletKey) => {
    if (!walletKey) return <span className="text-muted">-</span>;
    const key = String(walletKey).toUpperCase().trim();
    if (key.includes("PIN") || key.includes("DEPOSIT")) {
      return (
        <span className="badge bg-success-subtle text-success border border-success-subtle font-size-12 px-2 py-1">
          Deposit Wallet
        </span>
      );
    }
    if (key.includes("COMMISSION") || key.includes("INCOME")) {
      return (
        <span className="badge bg-primary-subtle text-primary border border-primary-subtle font-size-12 px-2 py-1">
          Income Wallet
        </span>
      );
    }
    return (
      <span className="badge bg-secondary-subtle text-secondary font-size-12 px-2 py-1">
        {walletKey.replace(/_/g, " ")}
      </span>
    );
  };


  const clearFilters = () => {
    setFilters({
      fromDate: "",
      toDate: "",
      transactionType: "All",
      walletType: "All",
    });
    setSearchTerm("");
    setFilteredTableData(tableData);
  };

  const handleSearch = () => {
    let result = [...tableData];
    if (filters.fromDate) {
      const from = new Date(filters.fromDate);
      from.setHours(0, 0, 0, 0);
      result = result.filter((item) => {
        const itemDateStr = item.ondate ? item.ondate.split(".")[0] : "";
        const itemDate = new Date(itemDateStr);
        return itemDate >= from;
      });
    }
    if (filters.toDate) {
      const to = new Date(filters.toDate);
      to.setHours(23, 59, 59, 999);
      result = result.filter((item) => {
        const itemDateStr = item.ondate ? item.ondate.split(".")[0] : "";
        const itemDate = new Date(itemDateStr);
        return itemDate <= to;
      });
    }

    if (filters.transactionType === "In") {
      result = result.filter((item) => Number(item.plus) > 0);
    } else if (filters.transactionType === "Out") {
      result = result.filter((item) => Number(item.minus) > 0);
    }

    if (filters.walletType && filters.walletType !== "All") {
      result = result.filter((item) => {
        if (!item.wallet) return false;
        const w = String(item.wallet).toUpperCase().trim();
        if (filters.walletType === "PIN_WALLET") {
          return w.includes("PIN") || w.includes("DEPOSIT");
        }
        if (filters.walletType === "COMMISSION_WALLET") {
          return w.includes("COMMISSION") || w.includes("INCOME");
        }
        return w === String(filters.walletType).toUpperCase().trim();
      });
    }

    if (searchTerm) {
      const searchLower = searchTerm.toLowerCase();
      result = result.filter((item) => {
        const matchesSearch =
          (item.wallet?.toString().toLowerCase().includes(searchLower)) ||
          (item.txid?.toString().toLowerCase().includes(searchLower)) ||
          (item.remark?.toString().toLowerCase().includes(searchLower));
        return matchesSearch;
      });
    }

    setFilteredTableData(result);
  };

  const [selectedItem, setSelectedItem] = useState(null);
  const [loading, setLoading] = useState(false);
  const [depositLoading, setDepositLoading] = useState(false);

  const copytext = (text) => {
    copy(text);
    MessageToster("success", `Wallet ID copied: ${text}`);
  };

  const getDepositHistoryData = async () => {
    setDepositLoading(true);
    try {
      const res = await axios.get(`${BASE_URL}/account/get_wallett_history`, { headers: getApiHeaders() });
      if (res.data && (res.data.code === 200 || res.data.status === "success" || res.data.status === true)) {
        const responseData = res.data.data || [];
        const actualData = Array.isArray(responseData) ? responseData.flat(Infinity) : [];
        setTableData(actualData);
        setFilteredTableData(actualData);
      } else {
        setTableData([]);
        setFilteredTableData([]);
        MessageToster("error", res.data?.message || "Something went wrong");
      }
    } catch (error) {
      handleError(error);
      setTableData([]);
      setFilteredTableData([]);
    } finally {
      setDepositLoading(false);
    }
  };

  // const checkBnbTransaction = async () => {
  //   setLoading(true);

  //   try {
  //     const res = await axios.get(
  //       `${BASE_URL}/deposit/check_bnb_transaction`,
  //       { headers: getApiHeaders() }
  //     );

  //     const response = res.data;

  //     if (response?.data) {
  //       const { BEP20, ERC20 } = response.data;

  //       if (BEP20?.MsgCode === "Success") {
  //         MessageToster("success", BEP20.Msg);
  //       }

  //       if (ERC20?.MsgCode === "Success") {
  //         MessageToster("success", ERC20.Msg);
  //       }
  //     } else if (response?.MsgCode === "Success") {
  //       MessageToster("success", response.Msg);
  //     } else if (response?.MsgCode === "Fail") {
  //       // Backend returned fail (e.g., "No wallet details found for this user.")
  //       // Normal check on page load when user has no crypto deposits/wallet
  //       console.log("Check BNB transaction:", response.Msg);
  //     }

  //   } catch (error) {
  //     handleError(error);
  //   } finally {
  //     setLoading(false);
  //     getWalletData();
  //   }
  // };

  useEffect(() => {
    getDepositHistoryData();
    if (fetchUserData) {
      fetchUserData();
    }
  }, []);

  // my_wallet / ewallet_id_balance 

  return (
    <>
      <div id="layout-wrapper">
        {loading && <Loader />}
        <Topbar />
        <Sidebar />
        <div className="main-content">
          <div className="page-content">
            <div className="container-fluid">
              {/* start page title */}
              <div className="row">
                <div className="col-12">
                  <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                    <h2 className="fw-700 mb-sm-0">My Wallet</h2>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-xl-3 col-md-6">
                  <div className="card card-animate overflow-hidden bg-primary-subtle">
                    <div className="card-body upcoming-box">
                      <div className="d-flex flex-wrap align-items-center">
                        <div className="me-3">
                          <p className="text-muted mb-2 fw-medium text-uppercase">Income Wallet</p>
                          <h4 className="d-flex align-items-center mb-0 gap-1 fw-bold">
                            {userData?.commissionwallet !== undefined && userData?.commissionwallet !== null
                              ? Number(userData.commissionwallet).toFixed(2)
                              : "0.00"} <span className="font-size-14 text-muted fw-normal"> USD</span>
                          </h4>
                        </div>
                        <div className="mini-stat-icon avatar-sm ms-auto">
                          <div className="avatar-title bg-primary rounded-circle upcoming-icon text-white font-size-20">
                            <i className="bx bx-wallet" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-xl-3 col-md-6">
                  <div className="card card-animate overflow-hidden bg-success-subtle">
                    <div className="card-body upcoming-box">
                      <div className="d-flex flex-wrap align-items-center">
                        <div className="me-3">
                          <p className="text-muted mb-2 fw-medium text-uppercase">Deposit Wallet</p>
                          <h4 className="d-flex align-items-center mb-0 gap-1 fw-bold">
                            {userData?.pinwallet !== undefined && userData?.pinwallet !== null
                              ? Number(userData.pinwallet).toFixed(2)
                              : "0.00"} <span className="font-size-14 text-muted fw-normal"> USD</span>
                          </h4>
                        </div>
                        <div className="mini-stat-icon avatar-sm ms-auto">
                          <div className="avatar-title bg-success rounded-circle upcoming-icon text-white font-size-20">
                            <i className="bx bx-dollar-circle" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* end page title */}

              <div className="row">
                <div className="col-12">
                  <div className="card">
                    <div className="card-body">
                      {/* ===================== DESKTOP VIEW ===================== */}
                      <div className="d-flex flex-wrap align-items-end gap-2 mb-4 desktop-filter-row">
                        <div>
                          <label className="form-label mb-1">From</label>
                          <input
                            className="form-control"
                            type="date"
                            onKeyDown={(e) => e.preventDefault()}
                            value={filters.fromDate}
                            onChange={(e) => setFilters({ ...filters, fromDate: e.target.value })}
                            max={filters.toDate ? (filters.toDate > new Date().toISOString().split("T")[0] ? new Date().toISOString().split("T")[0] : filters.toDate) : new Date().toISOString().split("T")[0]}
                          />
                        </div>
                        <div>
                          <label className="form-label mb-1">To</label>
                          <input
                            className="form-control"
                            type="date"
                            onKeyDown={(e) => e.preventDefault()}
                            value={filters.toDate}
                            onChange={(e) => setFilters({ ...filters, toDate: e.target.value })}
                            min={filters.fromDate || undefined}
                            max={new Date().toISOString().split("T")[0]}
                          />
                        </div>
                        <div>
                          <label className="form-label mb-1">Wallet Type</label>
                          <select
                            className="form-select"
                            value={filters.walletType}
                            onChange={(e) =>
                              setFilters({ ...filters, walletType: e.target.value })
                            }
                          >
                            <option value="All">All</option>
                            <option value="COMMISSION_WALLET">Income Wallet</option>
                            <option value="PIN_WALLET">Deposit Wallet</option>
                          </select>
                        </div>
                        <div>
                          <label className="form-label mb-1">Search</label>
                          <input
                            className="form-control"
                            type="text"
                            placeholder="Search..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                          />
                        </div>
                        <div>
                          <button
                            type="button"
                            className="btn btn-primary waves-effect waves-light"
                            onClick={handleSearch}
                          >
                            <span>Search</span>
                          </button>
                        </div>
                        <div>
                          <button
                            type="button"
                            className="btn btn-primary waves-effect waves-light d-flex align-items-center justify-content-center"
                            onClick={clearFilters}
                            disabled={!filters.fromDate && !filters.toDate && filters.walletType === "All" && !searchTerm}
                          >
                            <span>Clear</span>
                          </button>
                        </div>
                        <div className="ms-auto">
                          <ExportButton
                            disabled={!filteredTableData || filteredTableData.length === 0}
                            onClick={() => exportToExcel(filteredTableData, "Wallet_Transactions", "default")}
                          />
                        </div>
                      </div>
                      {/* ===================== MOBILE VIEW ===================== */}
                      <MobileFilter
                        title="History"
                        onExport={() => exportToExcel(filteredTableData, "Wallet_Transactions", "default")}
                        exportDisabled={!filteredTableData || filteredTableData.length === 0}
                      >
                        <div>
                          <label className="form-label mb-1">From</label>
                          <input
                            className="form-control"
                            type="date"
                            onKeyDown={(e) => e.preventDefault()}
                            value={filters.fromDate}
                            onChange={(e) => setFilters({ ...filters, fromDate: e.target.value })}
                            max={filters.toDate ? (filters.toDate > new Date().toISOString().split("T")[0] ? new Date().toISOString().split("T")[0] : filters.toDate) : new Date().toISOString().split("T")[0]}
                          />
                        </div>
                        <div>
                          <label className="form-label mb-1">To</label>
                          <input
                            className="form-control"
                            type="date"
                            onKeyDown={(e) => e.preventDefault()}
                            value={filters.toDate}
                            onChange={(e) => setFilters({ ...filters, toDate: e.target.value })}
                            min={filters.fromDate || undefined}
                            max={new Date().toISOString().split("T")[0]}
                          />
                        </div>
                        <div>
                          <label className="form-label mb-1">Wallet</label>
                          <select
                            className="form-select"
                            value={filters.walletType}
                            onChange={(e) => setFilters({ ...filters, walletType: e.target.value })}
                          >
                            <option value="All">All Wallets</option>
                            <option value="PIN_WALLET">Deposit Wallet</option>
                            <option value="COMMISSION_WALLET">Income Wallet</option>
                          </select>
                        </div>
                        <div>
                          <label className="form-label mb-1">Search</label>
                          <input
                            className="form-control"
                            type="text"
                            placeholder="Search..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                          />
                        </div>

                        <div className="d-flex gap-2 mt-2">
                          <button
                            type="button"
                            className="btn btn-primary waves-effect waves-light flex-grow-1"
                            onClick={handleSearch}
                            data-bs-dismiss="offcanvas"
                            data-bs-target="#filterOffcanvasMobile"
                          >
                            <span>Search</span>
                          </button>
                          <button
                            type="button"
                            className="btn btn-light waves-effect waves-light border flex-grow-1"
                            onClick={clearFilters}
                            disabled={!filters.fromDate && !filters.toDate && filters.walletType === "All" && !searchTerm}
                            data-bs-dismiss="offcanvas"
                            data-bs-target="#filterOffcanvasMobile"
                          >
                            <span>Clear</span>
                          </button>
                        </div>
                      </MobileFilter>
                      <CommonTable
                        columns={[
                          {
                            header: "Date",
                            accessor: "ondate",
                            render: (row) => formatDateDDMMYYYY(row.ondate),
                          },
                          {
                            header: "Wallet",
                            accessor: "wallet",
                            render: (row) => getWalletBadge(row.wallet),
                          },
                          {
                            header: "Note",
                            accessor: "note",
                            render: (row) => (
                              <span className="text-dark fw-medium">
                                {row.note || "-"}
                              </span>
                            ),
                          },
                          {
                            header: "Email",
                            accessor: "email",
                            render: (row) => (
                              <span title={row.email}>
                                {shortAddress(row.email)}
                              </span>
                            ),
                          },
                          {
                            header: "Deposit",
                            accessor: "plus",
                            render: (row) => (
                              <span className={Number(row.plus) > 0 ? "text-success fw-semibold" : "text-muted"}>
                                {row.plus !== undefined && row.plus !== null ? Number(row.plus).toFixed(2) : "0.00"}
                              </span>
                            ),
                          },
                          {
                            header: "Withdraw",
                            accessor: "minus",
                            render: (row) => (
                              <span className={Number(row.minus) > 0 ? "text-danger fw-semibold" : "text-muted"}>
                                {row.minus !== undefined && row.minus !== null ? Number(row.minus).toFixed(2) : "0.00"}
                              </span>
                            ),
                          },
                          {
                            header: "Remaining Balance",
                            accessor: "remainbalance",
                            render: (row) => (
                              <span className="fw-semibold text-dark">
                                {row.remainbalance !== undefined && row.remainbalance !== null ? Number(row.remainbalance).toFixed(2) : "0.00"}
                              </span>
                            ),
                          },
                          {
                            header: "Action",
                            render: (row) => (
                              <button
                                type="button"
                                className="btn btn-sm btn-soft-primary"
                                data-bs-toggle="modal"
                                data-bs-target="#detailModal"
                                onClick={() => setSelectedItem(row)}
                                title="View Details"
                              >
                                <i className="mdi mdi-eye-outline fs-5" />
                              </button>
                            ),
                          },
                        ]}
                        data={filteredTableData}
                        loading={depositLoading}
                      />
                    </div>
                  </div>
                </div>{" "}
                {/* end col */}
              </div>
            </div>
            {/* container-fluid */}
          </div>

          <div
            className="modal fade"
            id="detailModal"
            tabIndex={-1}
            aria-labelledby="detailModalLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog modal-dialog-centered modal-lg">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title fw-bold" id="detailModalLabel">
                    Wallet History Details
                  </h5>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  />
                </div>
                <div className="modal-body">
                  {selectedItem && (
                    <div className="transaction-details">
                      <div className="d-flex justify-content-between py-2 border-bottom">
                        <span className="fw-semibold text-muted">Date</span>
                        <span className="text-dark fw-medium">
                          {formatDateDDMMYYYY(selectedItem.ondate)}
                        </span>
                      </div>

                      <div className="d-flex justify-content-between py-2 border-bottom">
                        <span className="fw-semibold text-muted">Wallet</span>
                        <span>{getWalletBadge(selectedItem.wallet)}</span>
                      </div>

                      <div className="d-flex justify-content-between py-2 border-bottom">
                        <span className="fw-semibold text-muted">Note</span>
                        <span className="text-dark fw-medium">
                          {selectedItem.note || "-"}
                        </span>
                      </div>

                      <div className="d-flex justify-content-between py-2 border-bottom">
                        <span className="fw-semibold text-muted">Email</span>
                        <span title={selectedItem.email}>
                          {selectedItem.email || "-"}
                        </span>
                      </div>

                      <div className="d-flex justify-content-between py-2 border-bottom">
                        <span className="fw-semibold text-muted">Deposit</span>
                        <span className="text-success fw-bold">
                          +{Number(selectedItem.plus || 0).toFixed(2)}
                        </span>
                      </div>

                      <div className="d-flex justify-content-between py-2 border-bottom">
                        <span className="fw-semibold text-muted">Withdraw</span>
                        <span className="text-danger fw-bold">
                          -{Number(selectedItem.minus || 0).toFixed(2)}
                        </span>
                      </div>

                      <div className="d-flex justify-content-between py-2 border-bottom">
                        <span className="fw-semibold text-muted">Before Balance</span>
                        <span className="text-dark">
                          {Number(selectedItem.before_balance || 0).toFixed(2)}
                        </span>
                      </div>

                      <div className="d-flex justify-content-between py-2">
                        <span className="fw-semibold text-muted">Remaining Balance</span>
                        <span className="text-dark fw-bold">
                          {Number(selectedItem.remainbalance || 0).toFixed(2)}
                        </span>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* End Page-content */}
          <Footer />
        </div>
      </div>
    </>
  );
}